import Block from './Block'
import store from '../store'

export default class BackgroundVideo extends Block {
  onEnterCompleted() {
    this.isFirstView = true

    store.observer.observe({
      el: this.el,
      repeat: true,
      class: true,
      cb: (inView) => {
        this.launchVideo(inView)
      }
    })
  }

  getElems() {
    this.$video = this.el.querySelector('.c-background-video__video')
    this.$source = this.el.querySelector('.c-background-video source')
  }

  launchVideo(inView) {
    if (this.isFirstView) {
      this.isFirstView = false
      this.$source.src = this.$source.dataset.src
      this.$video.load()
    }

    if (inView) this.$video.play()
    else this.$video.pause()
  }
}
